var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { memoize } from '../../../utils/mobx/decorators/memoize';
import { ChoiceStore } from '../../Choice/modules/ChoiceStore';
import { primitive } from '../../../utils/serializr/schema/inner/primitive';
import { legacy } from '../../../utils/serializr/schema/outer/legacy';
import { disgardOldValue } from '../../../utils/serializr/schema/middle/disgardOldValue';
import { custom } from '../../../utils/serializr/schema/inner/custom';
import { editable } from '../../../utils/mobx/decorators/editable';
import { withInit } from '../../../utils/serializr/schema/middle/withInit';
import { MultipleChoiceLegacy } from './MultipleChoiceLegacy';
export class MultipleChoiceStore extends ChoiceStore {
    get multipleChoiceLegacy() {
        return new MultipleChoiceLegacy(this);
    }
    get questionTypeLegacy() {
        return this.multipleChoiceLegacy;
    }
    get option1() {
        return this.allOptions[0].innerTextString;
    }
    set option1(text) {
        this.allOptions[0].innerTextString = text;
    }
    get option2() {
        return this.allOptions[1].innerTextString;
    }
    set option2(text) {
        this.allOptions[1].innerTextString = text;
    }
    get option3() {
        return this.allOptions[2].innerTextString;
    }
    set option3(text) {
        this.allOptions[2].innerTextString = text;
    }
    get option4() {
        return this.allOptions[3].innerTextString;
    }
    set option4(text) {
        this.allOptions[3].innerTextString = text;
    }
    get option5() {
        return this.allOptions[4].innerTextString;
    }
    set option5(text) {
        this.allOptions[4].innerTextString = text;
    }
    get option6() {
        return this.allOptions[5].innerTextString;
    }
    set option6(text) {
        this.allOptions[5].innerTextString = text;
    }
    get option7() {
        return this.allOptions[6].innerTextString;
    }
    set option7(text) {
        this.allOptions[6].innerTextString = text;
    }
    get option8() {
        return this.allOptions[7].innerTextString;
    }
    set option8(text) {
        this.allOptions[7].innerTextString = text;
    }
    get option9() {
        return this.allOptions[8].innerTextString;
    }
    set option9(text) {
        this.allOptions[8].innerTextString = text;
    }
    get correct1() {
        return this.allOptions[0].shouldBeSelected ? 1 : 0;
    }
    set correct1(v) {
        this.allOptions[0].shouldBeSelected = !!v;
    }
    get correct2() {
        return this.allOptions[1].shouldBeSelected ? 1 : 0;
    }
    set correct2(v) {
        this.allOptions[1].shouldBeSelected = !!v;
    }
    get correct3() {
        return this.allOptions[2].shouldBeSelected ? 1 : 0;
    }
    set correct3(v) {
        this.allOptions[2].shouldBeSelected = !!v;
    }
    get correct4() {
        return this.allOptions[3].shouldBeSelected ? 1 : 0;
    }
    set correct4(v) {
        this.allOptions[3].shouldBeSelected = !!v;
    }
    get correct5() {
        return this.allOptions[4].shouldBeSelected ? 1 : 0;
    }
    set correct5(v) {
        this.allOptions[4].shouldBeSelected = !!v;
    }
    get correct6() {
        return this.allOptions[5].shouldBeSelected ? 1 : 0;
    }
    set correct6(v) {
        this.allOptions[5].shouldBeSelected = !!v;
    }
    get correct7() {
        return this.allOptions[6].shouldBeSelected ? 1 : 0;
    }
    set correct7(v) {
        this.allOptions[6].shouldBeSelected = !!v;
    }
    get correct8() {
        return this.allOptions[7].shouldBeSelected ? 1 : 0;
    }
    set correct8(v) {
        this.allOptions[7].shouldBeSelected = !!v;
    }
    get correct9() {
        return this.allOptions[8].shouldBeSelected ? 1 : 0;
    }
    set correct9(v) {
        this.allOptions[8].shouldBeSelected = !!v;
    }
    get legacyImages() {
        return undefined;
        //  return this.multipleChoiceLegacy.legacyImages;
    }
    set legacyImages(l) {
        if (!l)
            return;
        this.multipleChoiceLegacy.legacyImages = l;
    }
    get legacyComments() {
        return undefined;
        // return this.multipleChoiceLegacy.legacyComments;
    }
    set legacyComments(l) {
        if (!l)
            return;
        this.multipleChoiceLegacy.legacyComments = l;
    }
    displaymode;
    static get serializeInfo() {
        return {
            extends: ChoiceStore.serializeInfo,
            props: {
                option1: legacy(primitive),
                option2: legacy(primitive),
                option3: legacy(primitive),
                option4: legacy(primitive),
                option5: legacy(primitive),
                option6: legacy(primitive),
                option7: legacy(primitive),
                option8: legacy(primitive),
                option9: legacy(primitive),
                correct1: legacy(primitive),
                correct2: legacy(primitive),
                correct3: legacy(primitive),
                correct4: legacy(primitive),
                correct5: legacy(primitive),
                correct6: legacy(primitive),
                correct7: legacy(primitive),
                correct8: legacy(primitive),
                correct9: legacy(primitive),
                displaymode: withInit(primitive, 0),
                legacyImages: legacy(disgardOldValue(custom(a => a, a => a))),
                legacyComments: legacy(disgardOldValue(custom(a => a, a => a))),
            },
        };
    }
}
__decorate([
    memoize
], MultipleChoiceStore.prototype, "multipleChoiceLegacy", null);
__decorate([
    editable()
], MultipleChoiceStore.prototype, "displaymode", void 0);
__decorate([
    memoize
], MultipleChoiceStore, "serializeInfo", null);
